import React from 'react'
import PropTypes from 'prop-types'
import { gql, useQuery } from '@apollo/client'

import { List, Spin, Typography } from 'antd'
import * as Styled from './style'
import { formatNumber } from '../../../../utilties/number'

const GET_CART_SUMMARY = gql`
  query GetCartSummary($customerId: String!, $provinceId: ID!, $districtId: ID!, $shippingType: String) {
    customerCart(customerNo: $customerId) {
      id
      cartSummary(provinceId: $provinceId, districtId: $districtId, shippingType: $shippingType) {
        subtotal
        grandTotal
        vat
        lineItemTotal
        serviceLineItemsTotal
        offerDiscount
        couponDiscount
        shippingCostDiscount
        discountTotal
        discountLadderTotal
        displayVoucherType
        shippingCostAmount
        totalWeight
      }
    }
  }
`

const dataParser = data => {
  return {
    rows: [{
      title: 'ค่าจัดส่ง',
      dataIndex: 'shippingCostAmount'
    }, {
      title: 'ราคาก่อนภาษีมูลค่าเพิ่ม 7%',
      dataIndex: 'lineItemTotal'
    }, {
      title: 'ค่าบริการ',
      dataIndex: 'serviceLineItemsTotal'
    }, {
      title: 'ภาษีมูลค่าเพิ่ม 7%',
      dataIndex: 'vat'
    }, {
      title: 'ส่วนลดจากข้อเสนอพิเศษ',
      dataIndex: 'offerDiscount',
      type: 'discount'
    }, {
      title: 'ส่วนลดโปรยิ่งซื้อยิ่งลด',
      dataIndex: 'discountLadderTotal',
      type: 'discount'
    }],
    source: data ? data.customerCart.cartSummary : {}
  }
}

const displayPrice = price => {
  const formattedPrice = parseFloat(price)
  if (!price) return 'รอคำนวณ'
  if (price === '0.0') return '-'

  return formatNumber(formattedPrice)
}

const renderItem = ({ title, dataIndex }, source, loading) => {
  return (
    <List.Item>
      <Typography.Text>{title}</Typography.Text>
      {loading ? <Spin size="small" /> : (
        <Typography.Text>
          {displayPrice(source[dataIndex])}
        </Typography.Text>
      )}
    </List.Item>
  )
}

const renderFooter = (source, loading) => {
  return (
    <Styled.Footer>
      <Typography.Text strong>ยอดรวมสุทธิ</Typography.Text>
      {loading ? <Spin size="small" /> : (
        <Typography.Text type="danger" strong>
          {displayPrice(source.grandTotal)}
        </Typography.Text>
      )}
    </Styled.Footer>
  )
}

const CartSummary = ({
  customerId,
  provinceId,
  districtId,
  shippingType

}) => {
  const { loading, data, error } = useQuery(GET_CART_SUMMARY, {
    skip: !provinceId || !districtId,
    notifyOnNetworkStatusChange: true,
    variables: { customerId, provinceId, districtId, shippingType }
  })

  if (error) { console.error(error) }

  const { rows, source } = dataParser(data, loading)

  return (
    <Styled.Wrapper>
      <List
        header={<Styled.Header>สรุปยอดสั่งซื้อ</Styled.Header>}
        dataSource={rows}
        footer={renderFooter(source, loading)}
        renderItem={row => renderItem(row, source, loading)}
        size="small" />
    </Styled.Wrapper>
  )
}

CartSummary.propTypes = {
  customerId: PropTypes.string.isRequired,
  provinceId: PropTypes.string,
  districtId: PropTypes.string,
  shippingType: PropTypes.string
}

export default CartSummary
